module.exports = __webpack_public_path__ + "static/img/BI.9d2fcc10.jpg";